import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgZone } from '@angular/core';

declare var require: any;

@Component({
  selector: 'video-player',
  templateUrl: 'video-player.html',
  styleUrls: ['video-player.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class VideoPlayerComponent implements OnChanges, AfterViewInit {
  @Input() video!: string;
  @Input() autoPlay = false;
  @Input() id!: string | number;
  @Output() changeVideo = new EventEmitter();

  @ViewChild('playerContainer', { static: false }) playerContainer?: ElementRef;

  public innerWidth = window.innerWidth;
  public player: any;
  public videoId?: string;
  public safeUrl?: SafeResourceUrl;
  private ready = false;

  constructor(private sanitizer: DomSanitizer, private ngZone: NgZone) { }

  ngAfterViewInit() {
    // agora o DOM existe, pode inicializar o player
    this.ready = true;
    if (this.video) {
      this.startVideo(this.video);
    }
  }

  getPlayerId(): string {
    return `player-${this.id}`;
  }

  private extractVideoId(videoUrl: string): string | undefined {
    try {
      const url = new URL(videoUrl);
      if (url.searchParams.has('v')) return url.searchParams.get('v')!;
      if (videoUrl.includes('youtu.be/')) return videoUrl.split('youtu.be/')[1];
      if (videoUrl.includes('embed/')) return videoUrl.split('embed/')[1];
      return undefined;
    } catch {
      return undefined;
    }
  }

  startVideo(video: string): void {
    if (!this.ready) return;

    this.videoId = this.extractVideoId(video);
    if (!this.videoId) return;

    const autoplay = this.autoPlay ? '1' : '0';
    const url = `https://sis.sistemaprover.com.br/frontend/video-app.html?v=${this.videoId}&autoplay=${autoplay}`;

    this.ngZone.run(() => {
      setTimeout(() => {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['video']?.currentValue && this.ready) {
      setTimeout(() => {
        this.startVideo(changes['video'].currentValue);
      }, 100);
    }
  }
}
